/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Odesláno`
};

const da_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Afsendt`
};

const de_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Versandt`
};

const en_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Shipped`
};

const es_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado`
};

const fr_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Expédiée`
};

const hu_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítva`
};

const it_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Spedito`
};

const nl_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Verzonden`
};

const pl_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Wysłano`
};

const pt_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado`
};

const sv_order_statuses_complete = /** @type {(inputs: {}) => string} */ () => {
	return `Skickad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_complete = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_complete(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_complete", locale)
	if (locale === "cs") return cs_order_statuses_complete(inputs)
	if (locale === "da") return da_order_statuses_complete(inputs)
	if (locale === "de") return de_order_statuses_complete(inputs)
	if (locale === "en") return en_order_statuses_complete(inputs)
	if (locale === "es") return es_order_statuses_complete(inputs)
	if (locale === "fr") return fr_order_statuses_complete(inputs)
	if (locale === "hu") return hu_order_statuses_complete(inputs)
	if (locale === "it") return it_order_statuses_complete(inputs)
	if (locale === "nl") return nl_order_statuses_complete(inputs)
	if (locale === "pl") return pl_order_statuses_complete(inputs)
	if (locale === "pt") return pt_order_statuses_complete(inputs)
	return sv_order_statuses_complete(inputs)
};
export { order_statuses_complete as "order_statuses.complete" }